/**
 * Persistuje session token + expiraci (z `POST /v1/activate` response body)
 * tak, aby je mohly číst `BaseClient` (X-Session hlavička) a UI (countdown).
 *
 * Záměrně sessionStorage místo localStorage:
 * - přežije reload / klik na link v mailu
 * - nesdílí mezi taby / mezi browser session (žádoucí — cookie HttpOnly se taky neoddělí)
 */

const KEY_ID = 'apw_session_id';
const KEY_EXP = 'apw_session_expires';

export function getSessionId(): string | null {
  try {
    return sessionStorage.getItem(KEY_ID);
  } catch {
    return null;
  }
}

export function getSessionExpiresAt(): number | null {
  try {
    const v = sessionStorage.getItem(KEY_EXP);
    if (!v) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function setSession(sessionId: string, expiresAt: number): void {
  try {
    sessionStorage.setItem(KEY_ID, sessionId);
    sessionStorage.setItem(KEY_EXP, String(expiresAt));
  } catch {
    // sessionStorage může být zakázán (incognito + flag) — bez fallbacku
  }
}

export function clearSession(): void {
  try {
    sessionStorage.removeItem(KEY_ID);
    sessionStorage.removeItem(KEY_EXP);
  } catch {
    // ignore
  }
}
